// extracted by mini-css-extract-plugin
export default {"formWrapper":"ExpenseForm_formWrapper__wX-s1"};